import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 共済契約対象施設等一部廃止届一覧参照API
// API仕様書_施設
import {
  IAPI_FAC002_Request,
  IAPI_FAC002_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 共済契約対象施設等一部廃止届一覧参照API
// API仕様書_施設
const httpIAPI_FAC002 = async (
  param: IAPI_FAC002_Request
): Promise<IAPI_FAC002_Response> => {
  let res = await http.post(ApiUrl.API_FAC002, {
    // 課題　237
    ...param,
  });

  return res.data;
};

export { httpIAPI_APP016, httpIAPI_FAC002 };
